import { useEffect, useState } from "react"
import useFetchJson from "../../../data/useFetchJson"
import { Box, Divider, List, Typography } from "@mui/material"
import { DebugBox, LoadingBox } from "@northpowerdev/np-react-utils"
import { SearchField } from "../../styled/SearchField"
import { useGetParams } from "../../../utils/useGetParams"
import { DlspTaskListItem } from "./DlspTaskListItem"
import { plural } from "../../../utils/utilityFunctions"

export default function DlspSearchTask() {

    const [searchFilter, setSearchFilter] = useState(null)
    const getParams = useGetParams(['query'])

    const searchTasksPath = '/bff/decommissioned-lines-service/api/decommissioned-lines/search'
    const {
        isLoading: searchLoading,
        data: searchList, // [{ decommissionReason, decommissionDate, decommissionStatus, premiseType, address, addressNotes, dsub, dsubSuburb, stormArea, flag, icpOrientation, lvOrientation, icp, status, assignee, desktopInspBy, desktopInspDate, desktopInspTooHard, fieldInspBy, fieldInspDate}, ...]
        load: getSearch} = useFetchJson(searchTasksPath, {}, false) 


    useEffect(() => {

        function isAllDigits(someString) {
            return someString && someString.match(/^[0-9]+$/)
        }

        if (!searchFilter || searchFilter.length < 4 || (isAllDigits(searchFilter) && searchFilter.length !== 6)) {
            // It's less that 4 characters or it's all digits and it's not 6 characters.
            return
        }
        // console.log('DlspSearchTask useEffect searchFilter', searchFilter)
        const searchParams = {
            params: {
                search: searchFilter
            }
        }
        getSearch(searchParams) // async

    }, [getSearch, searchFilter]) 

    const handleSearchDlspTasks = (filterString) => {
        const trimmedFilterString = filterString?.trim() || filterString
        setSearchFilter(trimmedFilterString)
    }
 
    return (
        <Box className="Page">
            <h3>Decommissioned Lines Safety Project</h3>
            <h2>Search for a decommissioning task</h2>

            <Box sx={{}}>

                <SearchField onSearch={handleSearchDlspTasks} label="Search DLSP Tasks" defaultText={getParams?.query} helperText=""  />

                <Typography sx={{mt: 2}} variant="body2" paragraph>
                    Search by ICP number or address e.g. 503066 or 0000503066NR11E or Beach Road
                </Typography>
            </Box>

            <LoadingBox loading={searchLoading}>
                <Divider sx={{mb:4}} />
                {
                    searchList !== undefined
                    &&
                    <Typography variant="body1">We found {searchList?.length || 'no'} task{plural(searchList?.length)}.</Typography>
                }
                <List>
                {
                    searchList?.map((t, index) => {
                        return (
                            <DlspTaskListItem key={t.icpNumber || index} task={t} assignee={getParams?.assignee} />
                        )
                    })
                }
                </List>
                <DebugBox title="searchList" stringify>{searchList}</DebugBox>
            </LoadingBox>

        </Box>
    )
}
